import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { isHiddenDueLegal } from "..";
/**
 * Is the page currently a legal site?
 */

var preDecisionGatewayIsHiddenDueLegal = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(banner) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", isHiddenDueLegal(banner) ? "consent" : false);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayIsHiddenDueLegal(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayIsHiddenDueLegal };